module.exports = (__webpack_require__(13548))(672);